export class OrderLine {
	public Id: number;
	public OrderId: number;
	public EsoObjectId: number;
	public TransactionTypeId: number;
	
	public OrderDays: number;
	
	public ProposalQuantity: number;
	public ManualQuantity: number;
	public FinalQuantity: number;
	
	public OrderMeasure1: number;
	public OrderMeasure2: number;
	public OrderMeasure3: number;

	constructor(options?: { orderId: number, esoObjectId: number, orderDays: number, proposalQuantity: number }) {
		this.OrderId = options?.orderId;
		this.EsoObjectId = options?.esoObjectId;
		this.OrderDays = options?.orderDays;
		this.ProposalQuantity = options?.proposalQuantity;
	}
}
